/* eslint-disable react-hooks/exhaustive-deps */
import { useRef, useState, useEffect } from "react";
import classNames from "classnames";
import { useDebounce } from "use-debounce";
import { useOutsideClick } from "hooks";
import styled from "styled-components";
import { useQuery } from "react-query";
import { getRetailerByIdApi } from "api";
import { AiOutlineClose } from "react-icons/ai";
import { FaSearch } from "react-icons/fa";
import ClipLoader from "react-spinners/ClipLoader";
import "./style.scss";
import useKeypress from "react-use-keypress";

export const SearchByRetailerName = ({
  value,
  onChange,
  label,
  className,
  backgroundColor = "#eee",
  placeholder = "Search by retailer name",
  width,
  idField = "id",
  displayValue = "",
  func = () => {},
  onSelect = () => {},
  onSearch = () => {},
  onClick = () => {},
}) => {
  const menuRef = useRef(null);
  const componentRef = useRef(null);
  const [search, setSearch] = useState("");
  const [showResults, setShowResults] = useState(false);
  const [debouncedValue] = useDebounce(search, 500);
  const [innerValue, setInnerValue] = useState("");

  useOutsideClick(menuRef, clickOutsideMenu);
  useOutsideClick(componentRef, clickOutsideComponent);

  function clickOutsideMenu() {
    setShowResults(false);
    setCurrentIndex(null);
  }

  function clickOutsideComponent() {
    setFocused(false);
  }

  const handleChange = (params) => {
    if (params !== value) {
      setSearch("");
      onChange(params[idField]);
      onSelect(params[idField]);
      setInnerValue(params.name);
      // onSearch(params[idField]);
    }
    setShowResults(false);
  };

  const { data, isLoading, isFetching } = useQuery(
    [debouncedValue],
    () => func(debouncedValue),
    {
      keepPreviousData: true,
      enabled: debouncedValue.length > 0,
    }
  );

  const [focused, setFocused] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(null);

  const handleBlur = (event) => {
    setFocused(false);
  };

  const handleClear = () => {
    onChange("");
    setSearch("");
    onSelect("");
    setInnerValue("");
    setCurrentIndex(null);
    // onSearch("");
  };

  useEffect(() => {
    if (debouncedValue) {
      setShowResults(true);
    } else {
      setShowResults(false);
    }
    return () => {};
  }, [debouncedValue]);

  useEffect(() => {
    if (displayValue) {
      setInnerValue(displayValue);
    }
    return () => {};
  }, [displayValue]);

  useEffect(() => {
    if (value) {
      getInnerValue(value);
    } else {
      setInnerValue("");
    }
    return () => {};
  }, [value]);

  const getInnerValue = async (id) => {
    const res = await getRetailerByIdApi(id);
    if (res.success) {
      setInnerValue(res.results.name);
    }
  };

  const handleSearch = () => {
    onSearch(value);
  };

  useKeypress(["ArrowUp"], (event) => {
    if(focused)
    { 
      event.preventDefault();
      
      if(currentIndex === null)
      {
        setCurrentIndex(0);
      }
      else if(currentIndex > 0)
      {
        setCurrentIndex(currentIndex - 1);
        document.getElementsByClassName("selectedidx")[0].scrollIntoView();
      }
    }
  });

  useKeypress(["ArrowDown"], (event) => {
    if(focused) {
      event.preventDefault();

      if(currentIndex === null) {
        setCurrentIndex(0);
      }
      else if(currentIndex < (data.results.length - 1)) {
        setCurrentIndex(currentIndex + 1); 
        document.getElementsByClassName("selectedidx")[0].scrollIntoView();
      }
    }
  });
  
  useKeypress(["Enter"], (event) => {
    if(focused && currentIndex !== null && innerValue === "") {
      event.preventDefault();
      handleChange(data.results[currentIndex]);
    }
    else if(focused && innerValue !== "") {
      event.preventDefault();
      handleSearch();
      handleBlur();
    }
  });

  return (
    <div ref={componentRef} className={`d-flex search-container`} onClick={onClick}>
      <div className="search-retailer-by-name" style={{ width }}>
        <div className="menu-button" style={{ width }}>
          {innerValue ? (
            <>
              <span className="mr-auto"
                style={{
                  maxWidth: '85%',
                  textOrientation: 'elipses'
                }}
                onClick={() => setFocused(true)}>
                {innerValue}</span>
              <AiOutlineClose
                color="white"
                className="menu-button__drop-down"
                alt="clear"
                onClick={() => handleClear()}
              />
            </>
          ) : (
            <div className="d-flex w-100">
              <StyledInput
                type="text"
                aria-labelledby={"auto complete"}
                onFocus={() => setFocused(true)}
                onBlur={handleBlur}
                aria-describedby={"auto complete"}
                value={search}
                placeholder={placeholder}
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
              />

              {/* <AiFillCaretDown
                color="white"
                className="menu-button__drop-down"
                alt="drop-down"
              /> */}
            </div>
          )}

          <Underline focused={focused} />
        </div>
        {showResults && (
          <div ref={menuRef} className="menu-dropdown">
            {isLoading || isFetching ? (
              <div className="d-flex justify-content-center py-4">
                <ClipLoader size={32} color="#006280" />
              </div>
            ) : data?.results && data?.results.length > 0 ? (
              data.results.map((item, index) => {
                return (
                  <div
                    className={classNames(
                      "menu-item",
                      index === value ? "active" : "",
                      index === currentIndex ? "selectedidx" : "",
                    )}
                    key={`key${index}`}
                    onClick={() => handleChange(item)}
                    style={{ width }}
                  >
                    {item.name}
                  </div>
                );
              })
            ) : (
              <div className="my-3 d-flex justify-content-center">
                No results
              </div>
            )}
          </div>
        )}
      </div>

      <FaSearch className={"search-button"} onClick={handleSearch} />
    </div>
  );
};

const StyledInput = styled.input`
  background: transparent;
  color: white;
  border: none;
  height: 32px;
  line-height: 32px;
  width: calc(100% - 24px);
  font-size: 14px;
  outline: none;
  &:focus,
  &:hover {
    border: none;
    outline: none;
  }
`;

const Underline = styled.div`
  background: ${(props) => props.theme.palette.primary};
  width: calc(100% - 24px);
  height: 2px;
  position: absolute;
  bottom: 0;
  transform-origin: left;
  transition: transform 500ms ease;
  transform: ${(props) => (props.focused ? "" : "scale3d(0, 1, 1)")};
`;
